import { HttpResponseError } from 'src/service/backend/error/HttpResponseError'

export class ServerError extends HttpResponseError {}
